import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@mui/material";
import { Delete, Tag } from "@mui/icons-material";
import { useUsersContext } from "../../../../context/usersContext";
import LocalOfferSharpIcon from '@mui/icons-material/LocalOfferSharp';
import { useUserInfo } from "../../../../context/user";
import { useUpdateAgency, useUpdateAgent } from "../../../../queries/agents";

function SubCategoryPopup({ item, open, onClose, handleRefresh }) {
    const updateAgency = useUpdateAgency();
    const updateAgent = useUpdateAgent();
    const [waitingAdd, setWaitingAdd] = useState(false);
    const [waitingSave, setWaitingSave] = useState(false);
    const [newSubCategory, setNewSubCategory] = useState({ id: "", name: "" });
    const [selectedSubs, setSelectedSubs] = useState([]);
    const userActiveLocation = useUserInfo()[4]
    const { SSO, showToast, companyInfo, getLocationUsers, locationUsers, setOnFromPrompt, ChatSubmit, setUserAsUnread, addNewMessage, refresh,setCompanyInfo } = useUsersContext();

    const agency = companyInfo;

    useEffect(() => {
        if (agency?.SubCategories) {
            setSelectedSubs([]);
        }
    }, [agency?.SubCategories]);

    const handleCreateSubCategory = async (e) => {
        e.preventDefault();
        if (!newSubCategory.name) return;

        setWaitingAdd(true);
        const payload = {
            _id: userActiveLocation.agency_id,
            SubCategories: [...(agency?.SubCategories || []), newSubCategory],
        };

        try {
            const result = await updateAgency.mutateAsync(payload);
            setNewSubCategory({ id: "", name: "" });
            setCompanyInfo(result?.data);
        } catch (error) {
            console.log('An error occurred');
        } finally {
            setWaitingAdd(false);
        }
    };

    const handleSubmitSelection = async (e) => {
        e.preventDefault();
        setWaitingSave(true);

        const payload = {
            _id: item._id,
            subCategory: selectedSubs,
        };

        try {
            await updateAgent.mutateAsync(payload);
            handleRefresh();
            onClose();
        } catch (error) {
            console.log('An error occurred');
        } finally {
            setWaitingSave(false);
        }
    };

    useEffect(() => {
        if (agency?.SubCategories && item?.subCategory) {
            // Filter only those subcategories from agency list that exist in item.subCategory
            const existingSelected = agency.SubCategories.filter(sub =>
                item.subCategory.some(selected => selected.id === sub.id)
            );
            setSelectedSubs(existingSelected);
        }
    }, [agency?.SubCategories, item?.subCategory]);

    const updateAgencyCategories = async (updatedCategories) => {
        const payload = {
            _id: agency._id,
            SubCategories: updatedCategories,
        };

        try {
            const result = await updateAgency.mutateAsync(payload);
            if (result) {
                setCompanyInfo(result?.data);
            }
            handleRefresh()
        } catch (error) {
            console.log('An error occurred');
        }
    };

    const handleDelete = (id) => {
        const updatedCategories = agency?.SubCategories.filter(cat => cat.id !== id);
        updateAgencyCategories(updatedCategories);
    };

    return (
        <>
            {open && (
                <div className="modal-zz-confirm text-left">
                    <div className="p-2 scrollable-modal-content bg-card rounded" style={{ position: "relative" }}>
                        <h2 className="text-foreground text-left" style={{ fontWeight: "700", marginBottom: "10px" }}>
                            Manage Tags
                        </h2>
                        <span style={{ position: "absolute", top: "10px", right: "15px", cursor: "pointer" }} onClick={onClose}>
                            X
                        </span>

                        {/* Existing SubCategories with Checkboxes */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", height: "200px", overflowY: "auto" }}>
                            {agency?.SubCategories?.map((sub, index) => (
                                <label key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px", border: "1px solid hsl(var(--border))", borderRadius: "5px" }}>
                                    <span style={{ display: "flex", alignItems: "center", gap: "8px", height: '20px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedSubs.some((s) => s.id === sub.id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedSubs([...selectedSubs, sub]);
                                                } else {
                                                    setSelectedSubs(selectedSubs.filter((s) => s.id !== sub.id));
                                                }
                                            }}
                                        />
                                        {sub.name}
                                    </span>


                                    <p className="cursor-pointer" onClick={() => handleDelete(sub.id)} ><Delete fontSize="14"/></p>
                                </label>
                            ))}
                        </div>

                        {/* New SubCategory Form */}
                        <form onSubmit={handleCreateSubCategory} style={{ marginTop: "16px", marginBottom: "16px" }}>
                            <input
                                placeholder="New Tag Name"
                                style={{ width: "100%", padding: "8px", marginBottom: "8px", borderRadius: '5px', border: '1px solid hsl(var(--border))' }}
                                value={newSubCategory.name}
                                onChange={(e) => setNewSubCategory({ id: Date.now().toString(), name: e.target.value })}
                                disabled={waitingAdd}
                            />
                            <button
                                style={{ width: '100%', background: 'hsl(var(--card))', color: 'hsl(var(--foreground))', border: '1px solid hsl(var(--border))', padding: '10px 16px', borderRadius: '5px', opacity: waitingAdd ? 0.6 : 1, cursor: waitingAdd ? 'not-allowed' : 'pointer' }}
                                type="submit"
                                disabled={waitingAdd || !newSubCategory.name}
                            >
                                {waitingAdd ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></span> Adding...
                                    </span>
                                ) : "Add Tag"}
                            </button>
                        </form>

                        {/* Final Submit */}
                        <div style={{ marginTop: "16px" }}>
                            <button
                                className="savebtn-setting w-100"
                                type="button"
                                disabled={waitingSave}
                                onClick={handleSubmitSelection}
                                style={{ width: '100%', opacity: waitingSave ? 0.6 : 1, cursor: waitingSave ? 'not-allowed' : 'pointer' }}
                            >
                                {waitingSave ? (
                                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></span> Saving...
                                    </span>
                                ) : "Save Tags"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

SubCategoryPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleRefresh: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
};

function AddSubCategory({ handleRefresh, item }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <span
                onClick={() => setOpen(true)}
            >
                <LocalOfferSharpIcon className="!w-[20px] !h-[20px] text-muted-foreground cursor-pointer" />
            </span>

            <SubCategoryPopup item={item} open={open} onClose={() => setOpen(false)} handleRefresh={handleRefresh} />
        </>
    );
}

AddSubCategory.propTypes = {
    handleRefresh: PropTypes.func.isRequired,
};

export default AddSubCategory;
